<div class="care-event-validation-snackbar">
  <div class="care-event-validation-snackbar__content">
    <div class="care-event-validation-snackbar__header">
      <div class="care-event-validation-snackbar__message">
        {{ data.title }}<ng-container *ngIf="data.message"> — {{ data.message }}</ng-container>
      </div>
      <div class="care-event-validation-snackbar__actions">
        <button mat-button type="button" (click)="dismiss()">Dismiss</button>
      </div>
    </div>
    <div class="care-event-validation-snackbar__list" *ngIf="data.items?.length">
      <div class="care-event-validation-snackbar__item" *ngFor="let item of data.items">
        <div class="care-event-validation-snackbar__item-content">
          <div class="care-event-validation-snackbar__item-title">{{ item.name }}</div>
          <div class="care-event-validation-snackbar__item-meta">
            <span
              class="care-event-validation-snackbar__item-status"
              [class.is-approved]="item.isBcEligible === true"
              [class.is-rejected]="item.isBcEligible === false"
              [class.is-pending]="item.isBcEligible == null">
              <mat-icon *ngIf="item.isBcEligible === true">check_circle</mat-icon>
              <mat-icon *ngIf="item.isBcEligible === false">report_problem</mat-icon>
              <mat-icon *ngIf="item.isBcEligible == null">hourglass_empty</mat-icon>
              <span>
                {{ item.isBcEligible === true ? 'Approved' : item.isBcEligible === false ? 'Rejected' : 'Pending' }}
              </span>
            </span>
            <span *ngIf="item.benefitCheckReason" class="care-event-validation-snackbar__item-reason">
              — {{ item.benefitCheckReason }}
            </span>
          </div>
        </div>
        <div class="care-event-validation-snackbar__item-actions">
          <button
            *ngIf="item.canConvert"
            mat-button
            color="primary"
            type="button"
            (click)="convert(item)">
            Convert
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
